import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  query,
  where,
  orderBy,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from './firebase';
import type { ConnectedPlatform, PlatformContent } from '@/types';

const PLATFORMS_COLLECTION = 'connectedPlatforms';
const CONTENTS_COLLECTION = 'platformContents';

// Get user's Instagram connection
export const getInstagramConnection = async (userId: string): Promise<ConnectedPlatform | null> => {
  const q = query(
    collection(db, PLATFORMS_COLLECTION),
    where('userId', '==', userId),
    where('platform', '==', 'instagram')
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  const docSnap = snapshot.docs[0];
  return { id: docSnap.id, ...docSnap.data() } as ConnectedPlatform;
};

// Disconnect Instagram (delete connection doc)
export const disconnectInstagram = async (connectionId: string): Promise<void> => {
  await deleteDoc(doc(db, PLATFORMS_COLLECTION, connectionId));
};

// Trigger initial content sync
export const syncInstagramContent = async (): Promise<{ totalFetched: number; errors: number }> => {
  const fn = httpsCallable<void, { totalFetched: number; errors: number }>(functions, 'instagramContentFetch');
  const result = await fn();
  return result.data;
};

// Get user's platform contents
export const getUserContents = async (userId: string): Promise<PlatformContent[]> => {
  const q = query(
    collection(db, CONTENTS_COLLECTION),
    where('userId', '==', userId),
    orderBy('instagramTimestamp', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })) as PlatformContent[];
};
